import { format, compareAsc, compareDesc } from '../wrappers/date/date';
import { DATE_FORMATS } from './date.constants';

export const MONTH_DAY = 'MMM DD';
export const DAY_MONTH_YEAR = 'DD/MM/YYYY';
export const HOURS_MINUTES_SECONDS = 'HH:mm:ss';
export const MINUTES_SECONDS = 'mm:ss';
export const DAY_MONTH_YEAR_DATE_TIME = 'DD/MM/YYYY - hh:mm';
export const DAY_MONTH_YEAR_HOURS_MINUTES = 'DD/MM/YYYY HH:mm';
export const DAY_MONTH_YEAR_HOURS_MINUTES_SECONDS = 'YYYY/MM/DD HH:mm:ss';

const API_DATE_FORMAT = 'YYYY-MM-DD';

export const onDateFormat = (date: any, type: string, isUnix?: boolean) => {
    let target = date;

    if (isUnix) {
        target = Number(date) * 1000;
    }

    return format(target, type);
};

export const onSortAscByDate = (dates: string[]) => dates.sort(
    compareAsc,
);

export const onSortDescByDate = (dates: string[]) => dates.sort(
    compareDesc,
);

export const getDateFormatByLanguage = defaultLanguage => DATE_FORMATS[defaultLanguage]
|| DAY_MONTH_YEAR;

export const formatToApi = (date: string) => format(date, API_DATE_FORMAT);
